// Vite reads env vars at build time from VITE_* prefix.
interface DesktopEnv {
  VITE_API_URL: string;
  VITE_FIREBASE_API_KEY: string;
  VITE_FIREBASE_AUTH_DOMAIN: string;
  VITE_FIREBASE_PROJECT_ID: string;
  VITE_FIREBASE_STORAGE_BUCKET: string;
  VITE_FIREBASE_MESSAGING_SENDER_ID: string;
  VITE_FIREBASE_APP_ID: string;
  VITE_FIREBASE_VAPID_KEY: string;
  VITE_SENTRY_DSN: string;
  VITE_SENTRY_ENVIRONMENT: string;
  VITE_SENTRY_RELEASE: string;
}

/**
 * VITE_API_URL: explicit build-time env wins; otherwise infer from
 * window.location at runtime (localhost → http://localhost:4000, anything
 * else → https://api.underlings.com). Keeps the prod bundle portable.
 */
function resolveApiUrl(): string {
  const fromEnv = import.meta.env.VITE_API_URL as string | undefined;
  if (fromEnv) return fromEnv;
  if (typeof window === 'undefined') return 'http://localhost:4000';
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1' || /^192\.168\./.test(host)) {
    return 'http://localhost:4000';
  }
  return 'https://api.underlings.com';
}

export const env: DesktopEnv = {
  VITE_API_URL: resolveApiUrl(),
  VITE_FIREBASE_API_KEY: import.meta.env.VITE_FIREBASE_API_KEY ?? '',
  VITE_FIREBASE_AUTH_DOMAIN: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? '',
  VITE_FIREBASE_PROJECT_ID: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? '',
  VITE_FIREBASE_STORAGE_BUCKET: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? '',
  VITE_FIREBASE_MESSAGING_SENDER_ID: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? '',
  VITE_FIREBASE_APP_ID: import.meta.env.VITE_FIREBASE_APP_ID ?? '',
  VITE_FIREBASE_VAPID_KEY: import.meta.env.VITE_FIREBASE_VAPID_KEY ?? '',
  VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN ?? '',
  VITE_SENTRY_ENVIRONMENT: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? '',
  VITE_SENTRY_RELEASE: import.meta.env.VITE_SENTRY_RELEASE ?? '',
};
